<template>
  <v-badge
    v-show="!loading"
    v-bind="$attrs"
    :content="content"
    bordered
    :offset-x="-8"
    :offset-y="12"
    color="primary"
  >
    <v-icon size="28" :icon="icon" />
  </v-badge>
  <v-badge v-show="loading" :offset-x="-6" :offset-y="12" color="transparent">
    <v-icon size="28" :icon="icon" />
    <template #badge>
      <v-progress-circular indeterminate :size="15" color="primary" />
    </template>
  </v-badge>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false })

defineProps({
  icon: {
    type: String,
    required: true
  },
  content: {
    type: Number,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
})
</script>
